import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { EChartsOption } from 'echarts';
import { NgxEchartsDirective } from 'ngx-echarts';
import { colors } from '../../../theme-preset';

export interface SimpleBarChartData {
  category: string;
  value: number;
}

@Component({
  selector: 'app-simple-bar-chart-card',
  standalone: true,
  imports: [CommonModule, NgxEchartsDirective],
  templateUrl: './simple-bar-chart-card.component.html',
  styleUrl: './simple-bar-chart-card.component.scss',
})
export class SimpleBarChartCardComponent {
  titleText = input('');
  data = input<SimpleBarChartData[]>([]);
  color = input(colors.palette[0]);
  showLabels = input(true);
  orientation = input<'vertical' | 'horizontal'>('vertical');

  chartOptions = computed<EChartsOption | null>(() => {
    const data = this.data();
    if (!data.length) return null;

    const horizontal = this.orientation() === 'horizontal';
    const sorted = horizontal
      ? [...data].sort((a, b) => a.value - b.value)
      : data;

    const categoryAxis = {
      type: 'category' as const,
      data: sorted.map((d) => d.category),
      ...(horizontal ? { axisLabel: { fontSize: 12 } } : {}),
    };
    const valueAxis = { type: 'value' as const };

    return {
      color: [this.color()],
      tooltip: {
        trigger: 'axis',
        ...(horizontal ? { axisPointer: { type: 'shadow' as const } } : {}),
      },
      grid: horizontal
        ? { left: 20, right: 40, top: 10, bottom: 10, containLabel: true }
        : { left: 20, right: 20, top: 20, bottom: 30, containLabel: true },
      xAxis: horizontal ? valueAxis : categoryAxis,
      yAxis: horizontal ? categoryAxis : valueAxis,
      series: [
        {
          type: 'bar',
          data: sorted.map((d) => d.value),
          label: {
            show: this.showLabels(),
            position: horizontal ? 'right' : 'top',
            formatter: horizontal
              ? '{c}'
              : (params: any) => (params.value > 0 ? params.value : ''),
          },
        },
      ],
    };
  });
}
